import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button, Autocomplete, TextField } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useScreenWidth from "../../../hooks/useScreenWidth";

const UbahRabPekerjaan = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const { id, idRabPekerjaan } = useParams();
  const [validated, setValidated] = useState(false);
  // Data Rab
  const [noRab, setNoRab] = useState("");
  const [tanggalRab, setTanggalRab] = useState("");
  // Data Pekerjaan
  const [namaRabPekerjaan, setNamaRabPekerjaan] = useState("");
  const [jumlah, setJumlah] = useState("0");
  const [satuan, setSatuan] = useState("");
  const [keteranganRabPekerjaan, setKeteranganRabPekerjaan] = useState("");

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  let satuanOptions = [
    {
      label: "M2",
    },
    {
      label: "M",
    },
    {
      label: "UNIT",
    },
    {
      label: "SET",
    },
  ];

  useEffect(() => {
    getRabPekerjaanById();
  }, []);

  const getRabPekerjaanById = async () => {
    if (id) {
      const response = await postRequest(
        `/rabPekerjaans/${idRabPekerjaan}`,
        {},
        navigate,
        dispatch
      );
      // Data Rab
      setNoRab(response.data.rab.noRab);
      setTanggalRab(formatDate(response.data.rab.tanggalDpRab));

      // Data Pekerjaan
      setNamaRabPekerjaan(response.data.namaRabPekerjaan);
      setJumlah(response.data.jumlah.toLocaleString("en-US"));
      setSatuan(response.data.satuan.toLocaleString("en-US"));
      setKeteranganRabPekerjaan(
        response.data.keteranganRabPekerjaan.toLocaleString("en-US")
      );
    }
  };

  const updateRabPekerjaan = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      await postRequest(
        `/updateRabPekerjaan/${idRabPekerjaan}`,
        {
          // Data Rab
          noRab,
          rabId: id,

          // Data Pekerjaan
          namaRabPekerjaan: namaRabPekerjaan.replace(/,/g, ""),
          jumlah: jumlah.replace(/,/g, ""),
          satuan,
          keteranganRabPekerjaan,
        },
        navigate,
        dispatch
      );
      setLoading(false);
      navigate(`/daftarRab/rab/${id}/${idRabPekerjaan}`);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Pemraban</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Detail Rab Pekerjaan</h5>
      <hr />
      <Card>
        <Card.Header>Ubah Detail Rab Pekerjaan</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={updateRabPekerjaan}>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        No. RAB :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={noRab}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Tanggal :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={tanggalRab}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={namaRabPekerjaan}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Jumlah :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          value={jumlah}
                          onChange={(e) => setJumlah(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Satuan :
                      </Form.Label>
                      <Col sm="9">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={satuanOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          value={satuan}
                          onChange={(e, value) => {
                            if (value) {
                              setSatuan(value.label);
                            } else {
                              setSatuan("");
                            }
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Keterangan :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          as="textarea"
                          rows={4}
                          value={keteranganRabPekerjaan}
                          onChange={(e) => {
                            setKeteranganRabPekerjaan(e.target.value);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
            <Box>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() =>
                  navigate(`/daftarRab/rab/${id}/${idRabPekerjaan}`)
                }
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<EditIcon />}
                type="submit"
              >
                Edit
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default UbahRabPekerjaan;

const deleteButtonContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const colorRed = {
  color: "red",
};
